declare namespace $ {

	type $mol_touch__allow_draw_shm_hitalama_chart_line_pane_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line_pane['allow_draw'] >
		,
		ReturnType< $mol_touch['allow_draw'] >
	>
	type $mol_touch__allow_pan_shm_hitalama_chart_line_pane_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line_pane['allow_pan'] >
		,
		ReturnType< $mol_touch['allow_pan'] >
	>
	type $mol_touch__allow_zoom_shm_hitalama_chart_line_pane_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line_pane['allow_zoom'] >
		,
		ReturnType< $mol_touch['allow_zoom'] >
	>
	type $mol_touch__draw_start_shm_hitalama_chart_line_pane_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line_pane['draw_start'] >
		,
		ReturnType< $mol_touch['draw_start'] >
	>
	type $mol_touch__draw_shm_hitalama_chart_line_pane_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line_pane['draw'] >
		,
		ReturnType< $mol_touch['draw'] >
	>
	type $mol_touch__draw_end_shm_hitalama_chart_line_pane_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_chart_line_pane['draw_end'] >
		,
		ReturnType< $mol_touch['draw_end'] >
	>
	export class $shm_hitalama_chart_line_pane extends $mol_plot_pane {
		cursor_position( ): ReturnType< ReturnType< $shm_hitalama_chart_line_pane['Touch'] >['pointer_center'] >
		allow_draw( ): boolean
		allow_pan( ): boolean
		allow_zoom( ): boolean
		action_type( ): ReturnType< ReturnType< $shm_hitalama_chart_line_pane['Touch'] >['action_type'] >
		action_point( ): ReturnType< ReturnType< $shm_hitalama_chart_line_pane['Touch'] >['action_point'] >
		draw_start( next?: any ): any
		draw( next?: any ): any
		draw_end( next?: any ): any
		Touch( ): $mol_touch
	}
	
}

//# sourceMappingURL=pane.view.tree.d.ts.map